import GETS from './apis.get';
const CACHE_ARRAYS = [
  {
    key: 'HSYLC_STU_STATUS_DATA_OBJ',
    api: GETS.getUserStatus
  },
  {
    key: 'HSYLC_STU_SUCCESS_CARD_STATUS_DATA_OBJ',
    api: GETS.getStudentSuccessCardStatus
  },
  {
    key: 'HSYLC_STU_CLOCK_DATA_OBJ',
    api: GETS.getServerTime
  }
];
export const cleanCache = (arr = CACHE_ARRAYS) => {
  arr.forEach(item => {
    window[item.key] = null;
  });
};
export default CACHE_ARRAYS;
